// extracted by mini-css-extract-plugin
export default {"th":"WalletAcoesList_th__ntPq0","td":"WalletAcoesList_td__xPnVR","emphasis":"WalletAcoesList_emphasis__30nIF"};